
























import { Vue, Component, Prop, Watch, Model } from "vue-property-decorator";

interface RadioButtonItem {
  active: boolean;
  value: string;
  label: string;
}

@Component({})
export default class InputRadio extends Vue {
  @Model("change") public readonly value!: boolean;
  @Prop({ type: String, default: null }) public name!: string | null;
  @Prop({ type: String, default: undefined }) public label!: string;
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;
  @Prop({ type: Array, default: [] }) public val!: RadioButtonItem[];

  public inputValue = this.value;

  public updateInput(evt: any) {
    this.$emit("change", evt);
  }

  @Watch("inputValue")
  private onValueChanged(newValue: string, oldValue: string) {
    this.$emit("input", newValue);
  }
}
